<template>
  <Grid place-items="center" place-content="center" gap="var(--r-space-sm)">
    <div class="text-heading-1 text-secondary-1">{{ status }}</div>

    <RBtn type="text" size="small" @click="$emit('click')">
      {{ btnText }}
    </RBtn>
  </Grid>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: 'Cancelled'
    },
    btnText: {
      type: String,
      default: 'Undo'
    }
  }
}
</script>
